import axios from 'axios'
import { host } from '../../../helper/config'

const PLUGIN_NAME = 'admin-statistic'

export const getDashboardSummary = async (token, range) => {
  const response = await axios.post(`${host}/${PLUGIN_NAME}/dashboard-summary`, range, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      Authorization: token
    }
  })

  return response && response.status === 200 ? response.data : null
}

export const getDashboardPendingOrders = async (token) => {
  const response = await axios.post(`${host}/${PLUGIN_NAME}/dashboard-pending-orders`, {}, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      Authorization: token
    }
  })

  return response && response.status === 200 ? response.data : null
}
